/// <reference types="chrome"/>

import { ApiExtensionDisplayTypes } from "@/types/employees/employee.types.ts";

enum ExtensionMessageTypes {
  authToken = "auth_token",
  displayType = "display_type",
}

interface ExtensionMessage<T = unknown> {
  type: ExtensionMessageTypes;
  state: T;
}

const sendMessageToExtension = async <T>(type: ExtensionMessageTypes, state: T) => {
  const extensionId: string = import.meta.env.VITE_EXTENSION_ID as string;

  if (typeof chrome == "undefined" || typeof chrome.runtime == "undefined" || !extensionId) {
    return;
  }

  const message: ExtensionMessage<T> = { type: type, state: state };

  try {
    await chrome.runtime.sendMessage(extensionId, message);
  } catch (error) {
    console.error(`sendMessageToExtension: ${type}`, error);
  }
};

export const sendTokenToExtension = (token: string | null) => {
  void sendMessageToExtension(ExtensionMessageTypes.authToken, { token } as {
    token: string | null;
  });
};

export const sendDisplayTypeToExtension = (displayType: ApiExtensionDisplayTypes) => {
  void sendMessageToExtension(ExtensionMessageTypes.displayType, { displayType } as {
    displayType: ApiExtensionDisplayTypes;
  });
};
